import {useCallback, useEffect, useState} from "react";
import LoadingComponent from "../Loading/LoadingComponent";
import {baseApi} from "../../api/axios";
import OrderItem from "./OrderItem";
import {useAuthStore} from "../../store/user-store";

export default function OrderSectionComponent() {
    const [status, setStatus] = useState('pending')
    const [loading, setLoading] = useState(false)
    const [orders, setOrders] = useState([])
    const [page, setPage] = useState(1)
    const [nextPage, setNextPage] = useState(null)
    const [prevPage, setPrevPage] = useState(null)
    const [currentMonth, setCurrentMonth] = useState(0)
    const [prevMonth, setPrevMonth] = useState(0)
    const [search, setSearch] = useState('')
    const [debouncedSearch, setDebouncedSearch] = useState('')
    const authStore=useAuthStore()
    const nextPageNum = () => {
        setPage(page + 1)
    }
    const prevPageNum = () => {
        if (page > 1) {
            setPage(page - 1)
        }

    }

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search)
        }, 750) // ينتظر 500 مللي ثانية بعد آخر إدخال

        return () => {
            clearTimeout(handler) // يلغي الـ setTimeout إذا كتب المستخدم قبل انتهاء المهلة
        }
    }, [search])
    const getOrders =async () => {
        setLoading(true)
        try {
            const response = await baseApi(`/orders?page=${page}&status=${status}&search=${search}`)
            if (response && response.data) {
                setOrders(response.data.orders)
                setNextPage(response.data.next)
                setPrevPage(response.data.back)
                setCurrentMonth(response.data.current)
                setPrevMonth(response.data.prev)
            }
        } catch (e) {
            console.log('ERROR', e.response)
        }
        setLoading(false)
    }

    useEffect(() => {
        getOrders();
    }, [page,status,debouncedSearch]);
    if (loading) {
        return <div className={'container'}>
            <div className="row justify-content-center">
                <div className="col-6">
                    <LoadingComponent/>
                </div>
            </div>
        </div>
    } else {
        return <div className={'container my-4'}>
            <div className="row">
                <div className="col-md-4 col-6">
                   <div className="card card-success">
                        <div className="d-flex flex-column justify-content-center align-items-center bg-success" >
                        <span className={'text-white'}>مشتريات الشهر الحالي</span>
                        <span className={'text-white'}>{authStore.formatCurrency(currentMonth)}</span>
                    </div>
                   </div>
                </div>
                <div className="col-md-4  col-6">
                  <div className="card card-danger">
                        <div className="d-flex flex-column justify-content-center align-items-center bg-danger" >
                        <span className={'text-white'}>مشتريات الشهر السابق</span>
                        <span className={'text-white'}>{authStore.formatCurrency(prevMonth)}</span>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                    <span className="text-orange">المشتريات</span>
                </div>
                <div className="col-md-12">
                    <div className="d-flex  justify-content-between mb-1 ">
                        <button onClick={() => setStatus('pending')}
                                className={`btn btn-sm btn-outline-info ${status === 'pending' ? 'active' : ''}`}><span>مشتريات بالإنتظار</span>
                        </button>
                        <button onClick={() => setStatus('success')}
                                className={`btn btn-sm btn-outline-success ${status === 'success' ? 'active' : ''}`}>
                            <span>مشتريات مقبولة</span>
                        </button>
                        <button onClick={() => setStatus('cancel')}
                                className={`btn btn-sm btn-outline-danger ${status === 'cancel' ? 'active' : ''}`}>
                            <span>مشتريات مرفوضة</span>
                        </button>
                    </div>
                </div>
                <div className="col-12">
                    <div className="row justify-content-center">
                        <div className="col-md-6 ">
                            <div className="d-flex justify-content-center">
                                <input type="search" className={'input-form my-2 bg-white'} placeholder={'بحث'} onChange={(e) => setSearch(e.target.value)} value={search}/>
                            </div>
                        </div>
                    </div>
                </div>

                {orders.length > 0 ?
                    <div className="col-md-12">
                        {orders.length > 0 ? orders.map((el) => {
                            return <OrderItem key={el.id} order={el}/>
                        }) : null}

                        <div className="container">
                            <div className="col-12 text-center">
                                {prevPage !== null ?
                                    <button onClick={prevPageNum} className="btn-sm submit-btn">التالي</button> : null}
                                {nextPage !== null ? <button onClick={nextPageNum}
                                                             className="btn-sm submit-btn mx-1">السابق</button> : null}


                            </div>
                        </div>
                    </div>
                    : null}
                <div className="col-md-12">  {!loading && orders.length === 0 ?
                    <h6 className={'alert alert-danger'}>لا يوجد عناصر لعرضها</h6> : null}</div>
            </div>
        </div>


    }

}